<h3>{{ terminalList?.caption }}</h3>
@for (lists of terminalList?.containerList; track $index) {
  <div class="terminal-list-row" id="terminal-list-row"
    [style]="lists.inlineStyle ? layoutElementUtil.translateStyle(lists.inlineStyle) : ''">
    @for (group of lists?.containerList; track $index) {
      <div class="terminal-list-row-group"
        [style]="group.inlineStyle ? layoutElementUtil.translateStyle(group.inlineStyle) : ''">
        <div class="terminal-list-row-group-caption">{{ group.caption }}</div>
        @for (row of group.containerList; track $index) {
          <div [style]="row.inlineStyle ? layoutElementUtil.translateStyle(row.inlineStyle) : ''"
            class="terminal-list-row-item"
            >
            @if (layoutElementUtil.isTemperatureTextField(row)) {
              <div class="terminal-list-row-item-input">
                <app-temperature-text-field [temperatureTextField]="layoutElementUtil.asTemperatureTextField(row)"></app-temperature-text-field>
              </div>
            } @else {
              @if (layoutElementUtil.isTextField(row)) {
                <div class="terminal-list-row-item-input">
                  <app-text-field [textField]="layoutElementUtil.asTextField(row)"></app-text-field>
                </div>
              }
            }
            @if (layoutElementUtil.isComboBox(row)) {
              <div class="terminal-list-row-item-input">
                <app-combo-box
                  (copyEvent)="layoutElementUtil.copyComboBoxItemForAllInList($event,terminalList,row.containerId)"
                [comboBox]="layoutElementUtil.asComboBox(row)"></app-combo-box>
              </div>
            }
            @if (layoutElementUtil.isTerminalLabel(row)) {
              <div class="terminal-list-row-item-input">
                <app-terminal-label [label]="row"></app-terminal-label>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

